export function getItemName(productName?: string, serialNumber?: string) {
  return [productName, serialNumber].filter(Boolean).join(' - ') || '-'
}
